export default __webpack_public_path__ + "static/media/logo-accountpayables.492deae1.svg";